<template>
<div>
    <hr class="divisoria-colorida small">

    <section id="main-header" class="header-interna">
            <nav id="main-menu">
            <div class="container">
                <div class="row">
                    <div class="col-12">

                        <div class="header-container d-flex justify-content-between align-self-center">
                            <div class="open-menu-container d-block d-md-none">
                                <div id="nav-icon" class="toggle-menu" rel="button">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>

                            <div class="logo-header"><a href="https://eventos2.ecommercebrasil.com.br/forum/#"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/logo-forum-ecbr-2022-darkbg.webp" alt="Logo Fórum E-commerce Brasil 2022" class="img-fluid darkbg"><img id="logoMobile"  src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/logo-forum-ecbr-2022.webp" alt="Logo Fórum E-commerce Brasil 2022" class="img-fluid lightbg"></a></div>

                            <div class="menu-container flex-fill">
                                <div class="full-container">
                                    <ul class="menu d-flex justify-content-between">
                                        <li class="menu-item active"><a href="https://eventos2.ecommercebrasil.com.br/forum/#">Home</a></li>
                                        <li class="menu-item"><a href="https://eventos2.ecommercebrasil.com.br/forum/#experiencias">Experiências</a></li>
                                        <li class="menu-item"><a href="https://eventos2.ecommercebrasil.com.br/forum/palestrantes/">Palestrantes</a></li>
                                        <li class="menu-item"><a href="https://eventos2.ecommercebrasil.com.br/forum/#mapa-evento">Programação</a></li>
                                        <li class="menu-item"><a href="https://eventos2.ecommercebrasil.com.br/forum/#expositores">Expositores</a></li>
                                    </ul>

                                </div>
                            </div>
                            <div class="quero-participar"><a href="#inscricoes" class="btn">Inscreva-se</a></div>
                        </div>

                    </div>
                </div>
            </div> 
        </nav>    </section>
    
    
</div>
</template>
<script>

    export default{
        data() {
            return {
                isRestricted: process.env.VUE_APP_RESTRICT_VIEW=="false"?false:true,
            }
        },
        computed: {
            isLoggedIn() {
                return this.$isLoggedIn();
            },
            loggedUser() {
                return this.$loggedUser();
            },
            shortName() {
                let user = this.loggedUser;

                let userName = user.profile.name;

                let words = userName.split(" ");
                let short_name = words[0] +" "+ words[words.length-1];
                return short_name;
            },
            nameInitials() {
                let user = this.loggedUser;

                let userName = user.profile.name;

                let words = userName.split(" ");
                let short_name = words[0][0] + words[words.length-1][0];
                return short_name;

            }

        },
        methods: {
            logout(){
                this.$router.push('/user/logout');
            }
        }
    }
</script>

<style>

</style>
